<template>
  <v-dialog
    v-model="$loja_gerenciar.modalConfirm"
    width="500"
    class="rounded-xl"
    persistent
  >
    <div class="modal rounded-xl">
      <div class="modal-header base">
        <CloseIcon @action="closeModal" />
      </div>
      <div class="modal-container base">
        <v-row class="pa-2">
          <v-col cols="12">
            <span class="text-h5">{{ textModal }}</span>
          </v-col>
          <v-col
            cols="12"
            class="justify-center align-center text-center"
            v-if="warnText !== ''"
          >
            <span class="text-center subtitle-1">{{ warnText }}</span>
          </v-col>
        </v-row>
        <v-row class="pa-2 justify-center">
          <v-btn
            height="45"
            class="button btn-border"
            large
            :loading="$loja_gerenciar.cadastro.loading"
            @click="handleYes"
          >
            Sim
          </v-btn>
          <v-btn
            height="45"
            class="button btn-border btn-right"
            large
            @click="closeModal"
          >
            Não
          </v-btn>
        </v-row>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
export default {
  name: "ModalConfirmao",
  mixins: [LojasGerenciarMixins],
  props: {
    button1: {
      type: String,
      default: "Não",
    },
    warnText: {
      type: String,
      default: "",
    },
    textModal: {
      type: String,
      default: "Modal reutilizável para diversas ações",
    },
    button: {
      type: String,
      default: "Sim",
    },
    funcaoModal: {
      type: String,
    },
    execute: {
      type: Function,
    },
  },
  components: {
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
  },
  methods: {
    closeModal() {
      this.$loja_gerenciar.modalConfirm = false;
    },
    handleYes() {
      this.$emit("updateTable", this.funcaoModal);
      this.$emit("callback", this.execute);
      this.$loja_gerenciar.modalConfirm = false;
    },
  },
};
</script>

<style scoped>
.modal {
  width: 500px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 20px;
  background-color: #eaeaea !important;
}

.close-icon {
  width: 24px;
  height: 24px;
  margin-top: 3px;
  margin-right: 6px;
  transition: all 0.2s ease;
  position: relative;
  right: 2px;
}

.close-icon:hover {
  cursor: pointer;
  fill: #fff;
}

.modal-header {
  width: 100%;
  height: 1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}

.modal-container {
  width: 100%;
  height: 100%;
  padding: 1.25rem;
  border-bottom-left-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}

.modal-confirmao-container3 {
  flex: 0 0 auto;
  width: 100%;
  height: 70%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-size: 1.25rem;
  padding: 1.25rem;
  text-align: center;
}

.modal-confirmao-container4 {
  flex: 0 0 auto;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.modal-confirmao-button {
  width: 100px;
  color: var(--dl-color-gray-white);
  margin-right: 10px;
  background-color: #393939 !important;
  border-radius: 10px;
}

.modal-confirmao-button1 {
  width: 100px;
  color: var(--dl-color-gray-white);
  background-color: #393939 !important;
  border-radius: 10px;
}
</style>
